import { useAuth } from 'oidc-react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../state/reducers';
import LoaderPage from '../components/loader-page';

const SigoutContent = () => {
    const auth: any = useAuth();
    const { appConfig } = useSelector((x: RootState) => x.appConfig)
   
    useEffect(() => {
        // debugger
        if (appConfig) {
            auth.signOutRedirect({
                url: `${appConfig?.OIDC_AUTHORITY}/Account/Logout`
            });
        }
    }, [appConfig])
    return (
        <div>
            <LoaderPage />
        </div>
    );
};

export default SigoutContent;